/* eslint-disable */
/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 * Run `npm run generate-api` to regenerate.
 */
import { z } from 'zod';

import { zEnumWithUnknownFallback, zRequired } from '@/shared/redux/api/utils/zod-helpers';

export const vscodeValidators: Record<string, z.ZodTypeAny> = {
  "CreateVscodeSession": z.object({ "startVscodeSession": z.object({ "redirectUrl": z.string(), "launchToken": z.string(), "session": z.object({ "sessionId": z.string(), "state": zEnumWithUnknownFallback(["ACTIVE", "ENDED", "FAILED", "PENDING", "READY", "TIMED_OUT"]), "projectId": z.string(), "versionId": z.string() }) }) }),
  "ReadVscodeSession": z.object({ "vscodeSession": z.object({ "sessionId": z.string(), "state": zEnumWithUnknownFallback(["ACTIVE", "ENDED", "FAILED", "PENDING", "READY", "TIMED_OUT"]), "projectId": z.string(), "versionId": z.string() }).nullish() }),
};
